import { render, staticRenderFns } from "./accountConfirmation.vue?vue&type=template&id=b8838b56&scoped=true&"
import script from "./accountConfirmation.vue?vue&type=script&lang=js&"
export * from "./accountConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./accountConfirmation.vue?vue&type=style&index=0&id=b8838b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8838b56",
  null
  
)

export default component.exports